import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import * as AOS from 'aos';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-ai-on-manufacturing-challenges',
  templateUrl: './ai-on-manufacturing-challenges.component.html',
  styleUrls: ['./ai-on-manufacturing-challenges.component.css']
})
export class AiOnManufacturingChallengesComponent {
  isBrowser:boolean=false;
 
  constructor(
    private titleService: Title, @Inject(PLATFORM_ID) private platformId: any,
    private _renderer2: Renderer2,private seoService:SeoService,
    @Inject(DOCUMENT) private _document: Document,
    private metaService: Meta
  ) {this.isBrowser=isPlatformBrowser(this.platformId);
  }

  baseUrl = Constants.baseUrl;

  ngOnInit(): void {

    let script = this._renderer2.createElement('script');
      script.type = `application/ld+json`;
      script.text = `
{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/Exploring-the-Impact-of-AI-on-Manufacturing-Challenges-blog"
  },
  "headline": "Exploring the Impact of AI on Manufacturing Challenges",
  "description": "When we talk about what's driving competitiveness in the global economy these days, you can't help but shine a spotlight on Artificial Intelligence, or AI, especially in the manufacturing sector.",
  "image": "https://mitresource.com/assets/images/blogs/Exploring-the-Impact-of-AI-blog.webp",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-04-12"
}`;
     
      this._renderer2.appendChild(this._document.head, script);

    if(this.isBrowser){     
      AOS.init({disable: 'mobile'});
    }
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }

  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Exploring the Impact of AI on Manufacturing Challenges');

    this.metaService.addTags([
      { name: 'description', content: 'When we talk about what\'s driving competitiveness in the global economy these days, you can\'t help but shine a spotlight on Artificial Intelligence, or AI, especially in the manufacturing sector.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Exploring the Impact of AI on Manufacturing Challenges' },
      { property: 'og:url', content: 'https://mitresource.com/exploring-the-impact-of-ai-on-manufacturing-challenges/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/blogs/Exploring-the-Impact-of-AI-blog.webp' },
      { property: 'og:description', content: 'When we talk about what\'s driving competitiveness in the global economy these days, you can\'t help but shine a spotlight on Artificial Intelligence, or AI, especially in the manufacturing sector.' },
    ]);
  }
  


  scrollToSection(sectionId: string) {
    if(this.isBrowser){
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
  }
}
